import React from 'react';
import { HeroSection } from './sections/HeroSection';
import { TextSection, TextImageSection, ImageSection, VideoSection, EmbedSection, DividerSection } from './sections/ContentSections';
import { GallerySection, BeforeAfterSection } from './sections/MediaSections';
import { ProductGridSection, CategoryGridSection, CollectionGridSection, FabricGridSection, ProjectsSection, BlogGridSection, RelatedSection } from './sections/CatalogSections';
import { FeaturesSection, StatsSection, LogosSection, TestimonialsSection, FaqSection, SpecsSection, ComparisonSection, DownloadsSection } from './sections/InfoSections';
import { CtaSection, FormSection } from './sections/CtaFormSections';
import { ContactInfoSection } from './sections/ContactInfoSection';
import { CardGridSection } from './sections/CardGridSection';
import { SplitLogosSection } from './sections/SplitLogosSection';
import { FabricVisualizerSection } from './sections/FabricVisualizerSection';
import { ProductContentSection, ProductTopicSection, RoomGuideSection } from './sections/ProductContentSection';
import { OpennessComparisonSection } from './OpennessComparison';

// Add a new section type here + in backend/data/website_registry.py
export const SECTION_COMPONENTS = {
  openness_comparison: OpennessComparisonSection,
  product_topic: ProductTopicSection,
  room_guide: RoomGuideSection,
  product_content: ProductContentSection,
  contact_info: ContactInfoSection, card_grid: CardGridSection, split_logos: SplitLogosSection,
  fabric_visualizer: FabricVisualizerSection,
  hero: HeroSection, text: TextSection, text_image: TextImageSection, image: ImageSection, video: VideoSection,
  gallery: GallerySection, before_after: BeforeAfterSection,
  product_grid: ProductGridSection, category_grid: CategoryGridSection, collection_grid: CollectionGridSection, fabric_grid: FabricGridSection,
  features: FeaturesSection, stats: StatsSection, logos: LogosSection, testimonials: TestimonialsSection, projects: ProjectsSection,
  faq: FaqSection, specs: SpecsSection, comparison: ComparisonSection, cta: CtaSection, form: FormSection,
  downloads: DownloadsSection, blog_grid: BlogGridSection, related: RelatedSection, embed: EmbedSection, divider: DividerSection,
};

export const SectionRenderer = ({ sections = [], editor = false, selectedId, onSelect }) => {
  const visible = sections.filter((s) => editor || !s.hidden);
  return (
    <>
      {visible.map((section, index) => {
        const Comp = SECTION_COMPONENTS[section.type];
        if (!Comp) return null;
        const node = <Comp section={section} isFirst={index === 0} sections={visible} />;
        if (!editor) return <React.Fragment key={section.id}>{node}</React.Fragment>;
        return (
          <div key={section.id} onClick={() => onSelect?.(section.id)} data-testid={`editor-section-${section.id}`}
            className={`relative cursor-pointer transition-shadow ${section.hidden ? 'opacity-40' : ''} ${selectedId === section.id ? 'ring-2 ring-inset ring-amber-500' : 'hover:ring-2 hover:ring-inset hover:ring-amber-300'}`}>
            {node}
          </div>
        );
      })}
    </>
  );
};

export default SectionRenderer;
